/**
 * @module router/modules/consultation
 * @description 상담 도메인 라우트 모듈 — 상담 등록, 상담 이력, 상담 이력 상세 페이지 경로를 정의합니다.
 */
const routes = [
  {
    path: '/consultation-reception',
    name: '상담 등록',
    component: () => import(/* webpackChunkName: "counselReceipt" */ '../../views/consultation/ConsultationReception.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/consultation-history',
    name: '상담 이력',
    component: () => import(/* webpackChunkName: "consultationHistory" */ '../../views/consultation/ConsultationHistory.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    path: '/consultation/:consultationId',
    name: '상담 이력 상세',
    component: () => import(/* webpackChunkName: "consultationHistoryDetail" */ '../../views/consultation/ConsultationHistoryDetail.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  }
]

export default routes
